import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import { sortBy } from 'lodash';
import scrollToTopOfProductGrid from 'components/consumer/ProductCardGridUI/helpers/scrollToTopOfProductGrid';
import useProductListingUrlSortByState from './useProductListingUrlSortByState';
const getSortedProducts = (products = [], sortOrder) => {
  if (['featured', 'popularity', 'newest'].includes(sortOrder)) {
    return sortBy(products, product => product.sortOrder[sortOrder]);
  }
  if (sortOrder === 'alphabetical') {
    return sortBy(products, product => product.name.toLowerCase());
  }
  if (sortOrder === 'priceLowToHigh') {
    return sortBy(products, product => product.variants[0].price);
  }
  if (sortOrder === 'priceHighToLow') {
    return sortBy(products, product => product.variants[0].price).slice().reverse();
  }
  return products;
};
const useProductListingSorting = (products, t0) => {
  const $ = _c(15);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  const {
    skipSorting: t2
  } = options;
  const skipSorting = t2 === undefined ? false : t2;
  const [sortOrder, setSortOrder] = useProductListingUrlSortByState();
  let t3;
  if ($[2] !== setSortOrder) {
    t3 = updatedSortOrder => {
      scrollToTopOfProductGrid();
      setTimeout(() => {
        setSortOrder(updatedSortOrder);
      }, 0);
    };
    $[2] = setSortOrder;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const setSortOrderAndScrollToTop = t3;
  let t4;
  if ($[4] !== products || $[5] !== skipSorting || $[6] !== sortOrder) {
    t4 = skipSorting ? products : getSortedProducts(products, sortOrder);
    $[4] = products;
    $[5] = skipSorting;
    $[6] = sortOrder;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const productsSorted = t4;
  let t5;
  if ($[8] !== productsSorted || $[9] !== skipSorting) {
    t5 = skipSorting ? productsSorted : productsSorted?.sort(_temp);
    $[8] = productsSorted;
    $[9] = skipSorting;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const productsSortedWithOutOfStockAtEnd = t5;
  let t6;
  if ($[11] !== productsSortedWithOutOfStockAtEnd || $[12] !== setSortOrderAndScrollToTop || $[13] !== sortOrder) {
    t6 = {
      productsSorted: productsSortedWithOutOfStockAtEnd,
      sortOrder,
      setSortOrder: setSortOrderAndScrollToTop
    };
    $[11] = productsSortedWithOutOfStockAtEnd;
    $[12] = setSortOrderAndScrollToTop;
    $[13] = sortOrder;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default useProductListingSorting;
function _temp(productA, productB) {
  return productA.variants[0].isOutOfStock - productB.variants[0].isOutOfStock;
}